import styled, { keyframes } from 'styled-components';

export const rotationBackgroundAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(4deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

export const rotationForegroundAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-4deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

export const IconContainer = styled.svg`
  g > path {
    filter: drop-shadow(0px 0px 2px rgb(0 0 0 / 0.4));
  }
  .background {
    transform-origin: 0 50%;
    animation: ${rotationBackgroundAnimation} 4s infinite;
  }
  .foreground {
    transform-origin: 100% 50%;
    animation: ${rotationForegroundAnimation} 5s infinite;
    animation-delay: 0.5s;
  }
`;
